import React, { useCallback, useEffect, useMemo, useState, useRef } from 'react';
import { useHistory, useParams } from 'react-router-dom'
import { getPatientById, updateFiscalInformationPatient } from '../../services/patient/patient';
import { GetInvoiceId, getPayForms, sendStampIngress, sendGlobalInvoices, sendPatientInvoices, GetSettingsInvoice } from '../../services/invoice/invoice';
import { validarSesion } from '../tokens/useToken';
import { useSweetAlert } from '../sweetAlerts/useSweetAlert';
import { getAllCommercialLines, getAllBranches } from '../../services/commercialLine/commercialLine';
import { getAllClients, getCompanyBusinessNameByClientId, updateFiscalInformationClient } from '../../services/clients/clients';
import { getListUseOfCfdi } from '../../services/invoice/useCfdi';
import { getDetailWorkOrderByInvoice, getDetailWorkOrdersByDateRange, getDetailWorkOrdersByGeneralPublic, getWorkOrderByPatientOrCompany } from '../../services/workOrders/workOrders';
import { getTaxRegimeByTypePerson } from '../../services/invoice/taxRegime';
import { FormatAmount } from '../../utils/formatNumbers';
import ReceptorInvoice from '../../utils/enum/ReceptorInvoice';
import InformationGeneralPublicEnum, { listOfMonthsByGroupEnum, listOfMonthsEnum, listPeriodicityEnum, TypeVIsualizationEnum } from '../../utils/enum/Invoice_enum';
import TypePersonInvoiceEnum from '../../utils/enum/type_person.enum';
import ValidateFiscalFormPatient from '../../utils/validations/patientValidations';
import ValidateFiscalFormClient from '../../utils/validations/clientValidations';
import moment from 'moment';
import { getListBranches } from '../../services/branches/branches';
import { useModal } from "react-morphing-modal";
import { cedimi } from '../../constant/globalConstantsTypeClients'
import { getInformationAgreement } from '../../services/company/company';




export const useInvoiceService = () => {

	const branchId = localStorage.getItem('branchId');
	const urlClient = localStorage.getItem('url_helen');
	// ? ACTIVE MICROSANITARY
	let _active_micro = localStorage.getItem('active_microsanitary');
	let _title_dashboard = localStorage.getItem('title_dashboard');

	const { id_work_order_r, id_patient_r, _id_company_r, request_id_invoice } = useParams();

	const listPayMethods = [
		{
			value: "PUE",
			label: "(PUE) PAGO EN UNA SOLA EXHIBICIÓN",
		},
		{
			value: "PPD",
			label: "(PPD) PAGO EN PARCIALIDADES O DIFERIDO"
		}
	];

	const listOfPeriodicity = listPeriodicityEnum;

	const history = useHistory();
	const [createSweet, sweetConfirmation, sweetDelete, sweetError, createSweett] = useSweetAlert()

	const [byDashboard, setByDashboard] = useState(false);
	const [disableStampOrder, setDisableStampOrder] = useState(false);

	// * MODALS
	const [showUpdateFiscalInformationPatient, setShowUpdateFiscalInformationPatient] = useState(false);
	const [showUpdaetFiscalInformationClient, setShowUpdaetFiscalInformationClient] = useState(false)
	const [showExtraPatient, setShowExtraPatient] = useState(false);
	const [showPreviewInvoice, setShowPreviewInvoice] = useState(false);
	const [showLoading, setShowLoading] = useState(false);
	const [showError, setShowError] = useState(false);
	const [showPreviewInvoicesGlobal, setShowPreviewInvoicesGlobal] = useState(false);
	const [showPreviewInvoicesPatient, setShowPreviewInvoicesPatient] = useState(false);



	// * CARD VIEWS
	const [showCardFilterByDate, setShowCardFilterByDate] = useState(false);

	// * VALIDATIONS

	const [validationsPatient, setValidationsPatient] = useState({
		id_tax_regime_patient_valid: false,
		rfc_patient_valid: false,
		cp_patient_valid: false,
		email_valid: false,
		business_name_patient_valid: false
	});

	const [validationsBusinessName, setValidationsBusinessName] = useState({
		id_tax_regime_business_name_valid: false,
		business_name_valid: false,
		cp_business_name_valid: false,
		rfc_business_name_valid: false,
	});

	const [viewInformationReceptor, setViewInformationReceptor] = useState(false);
	const [filterTypeReceptor, setFilterTypeReceptor] = useState('');
	const [viewInformationIssuing, setViewInformationIssuing] = useState(false);
	const [isEditInvoice, setIsEditInvoice] = useState(false);

	const [value_tax, setValue_tax] = useState(16)


	// * FORM INVOICE
	const [formInvoice, setFormInvoice] = useState({
		invoice_id: null,
		patient_id: null,
		client_id: null,
		client_business_id: null,
		commercial_line_id: null,
		receptor_information: null,
		issuing_information: null,
		type: null,
		branch_id: branchId,
		pay_form_id: null,
		pay_method_id: null,
		use_cfdi_id: null,
		is_general_public: false,
		periodicity_id: null,
		month_id: null,
		year_billing: {
			label: moment().format('YYYY'),
			value: moment().format('YYYY'),
		},
		expedition_place: null,
		payment_conditions: null,
		comments: "",
		include_name_patient: true,
		include_detail_period: false,
		include_sells: false,
		type_visualization: TypeVIsualizationEnum.DETAIL,
		listOrders: [],
		viewGeneral: {
			productCode: "",
			unitCode: "",
			nameUnit: "",
			numberIdentification: "",
			description: "",
			unitPrice: 0,
			import: 0,
			discount: 0,
			tax: 0,
			retention: 0,
			total: 0,
		},
		viewGroup: [],
		global_description: '',
		is_date: false,
		date_remission: null,
		search_agreement: false,
		id_agreement: null,
		id_payment_configuration: 0,
		days_credit: 0,
		is_stamp: true


	});
	console.log("🚀 ~ useInvoiceService ~ formInvoice:", formInvoice)

	const [formPatientFiscalInformation, setFormPatientFiscalInformation] = useState({
		tax_regime_id_patient: 0,
		code_tax_regime: "",
		name_patient: "",
		business_name_patient: '',
		type_person_patient: TypePersonInvoiceEnum.FISICA,
		cp_patient: '',
		rfc_patient: '',
		email_patient: ''
	});

	const [formCompanyFiscalInformation, setFormCompanyFiscalInformation] = useState({
		tax_regime_id_client: 0,
		business_name_client: "",
		rfc_client: "",
		cp_client: "",
		email_client: "",
		type_person_client: TypePersonInvoiceEnum.MORAL,
		code_tax_regime_client: ""
	})

	const [optionsDue, setOptionsDue] = useState({
		subtotal: 0,
		discounts: 0,
		tax: 0,
		retentions: 0,
		total: 0
	});

	// * LIST DATA
	const [listCommercialLines, setListCommercialLines] = useState([]);
	const [listClients, setListClients] = useState([]);
	const [listPayForms, setListPayForms] = useState([]);
	const [listPayFormsWorkOrder, setListPayFormsWorkOrder] = useState([]);
	const [listUseOfCfdis, setListUseOfCfdis] = useState([]);
	const [listTaxRegimes, setListTaxRegimes] = useState([]);
	const [listClientCompanyBUsinessName, setListClientCompanyBUsinessName] = useState([]);
	const [listWorkOrdersTemp, setListWorkOrdersTemp] = useState([]);
	const [listFilterNims, setListFilterNims] = useState([]);
	const [listOfMonths, setListOfMonths] = useState([]);
	const [listBranches, setListBranches] = useState([]);

	// * SEARCH SELECTS
	const [searchPatientState, setSearchPatientState] = useState([]);
	const searchExtraPatient = [];
	const [searchValueInput, setSearchValueInput] = useState('');
	const [selectCompany, setSelectCompany] = useState(null);
	const [selectCommercialNameCompany, setSelectCommercialNameCompany] = useState(null);
	const [filterByBranch, setFilterByBranch] = useState(null);
	const [filterByPayMethod, setFilterByPayMethod] = useState(null);

	// * FILTER DATES
	const [filterDateRanges, setFilterDateRanges] = useState({
		startDate: moment().format("YYYY-MM-DD"),
		endDate: moment().format("YYYY-MM-DD")
	});

	// * LOADING WORK ORDERS
	const [isLoadingWorkOrders, setIsLoadingWorkOrders] = useState(false);
	const [loadingPreview, setLoadingPreview] = useState(false);
	const [loadingPreviewInvoices, setLoadingPreviewInvoices] = useState(false);
	const [loadingPreviewInvoicesP, setLoadingPreviewInvoicesP] = useState(false);


	// * CONFIGURATION GLOBAL INVOICE
	const [checkedItems, setCheckedItems] = useState({});
	const [loadingGlobal, setLoadingGlobal] = useState(false)

	// * CONFIGURATION DATE REMISSION
	const today = moment();
	const twoDaysAgo = moment().subtract(3, 'days');

	// * CONFIGURATION REQUIRES INVOICE PATIENT
	const [checkedItemsPatient, setCheckedItemsPatient] = useState({});
	const [loadingGlobalPatient, setLoadingGlobalPatient] = useState(false)

	// *SETTING FOLIOS
	const [listSettings, setListSettings] = useState([])



	//#region  USE EFFECTS FIRST LOADING

	useEffect(() => {
		GetCommercialLines();
		GetPayForms();

	}, []);

	useEffect(() => {
		typeVisualizationTable();
	}, [formInvoice.type_visualization]);

	useEffect(() => {
		if (request_id_invoice !== undefined)
			GetInvoiceById();
	}, [request_id_invoice]);

	const [key, setKey] = useState(0);
	const modalFullRef = useRef(null);



	//*OPEN FINAL REPORT
	const { close, modalProps, open } = useModal({
		onClose: () => setKey(key => key + 1),
		background: "#fff"

	});

	const handleReport = (receptor) => {


		open(modalFullRef);
		handleChangeTyepeReceptor(receptor)
	}




	const refetchAutoCompany = useCallback(async () => {

		if (_id_company_r !== undefined && parseInt(_id_company_r) > 0) {
			open(modalFullRef);


			console.log("aca entra cuando se carga en el dashboard");


			handleChangeTyepeReceptor(ReceptorInvoice.COMPANY)
			const listBusinessNameClient = await getCompanyBusinessNameByClientId(_id_company_r);
			console.log("🚀 ~ useInvoiceService ~ listBusinessNameClient:", listBusinessNameClient)
			console.log("artemis");

			const commercialLines = await getAllCommercialLines();
			await GetListNimsByReceptor(
				null, _id_company_r, formInvoice.search_agreement === true ? formInvoice.id_agreement.value : null
			);
			const branches = await getAllBranches();

			let _cp = branches.find(x => x.id_branch === parseInt(branchId))?.cp ?? null;

			let defaultOptionClient = null;
			let defaultOptionCommercial = null;

			if (listBusinessNameClient?.length > 0) {
				defaultOptionClient = {
					"value": listBusinessNameClient[0]?.id_company_business_name,
					"id_company": listBusinessNameClient[0]?.id_company,
					"name_commercial_line": listBusinessNameClient[0]?.business_name,
					"tax_regime_id": listBusinessNameClient[0]?.id_tax_regime ?? null,
					"use_cfdi_id": null,
					"code_fiscal_regime": listBusinessNameClient[0]?.code_tax_regime,
					"name_fiscal_regime": listBusinessNameClient[0]?.name_tax_regime,
					"rfc": listBusinessNameClient[0]?.rfc ?? "",
					"expedition_place": listBusinessNameClient[0]?.cp ?? "",
					"type_person": listBusinessNameClient[0]?.type_person === 2 ? TypePersonInvoiceEnum.MORAL : TypePersonInvoiceEnum.FISICA,
					"code_use_cfdiL": listBusinessNameClient[0]?.code_use_cfdi ?? null,
					"name_use_cfdi": listBusinessNameClient[0]?.name_use_cfdi ?? null,
					"email": listBusinessNameClient[0]?.email ?? "",
				};

				if (listBusinessNameClient[0]?.id_tax_regime !== null)
					await GetUseCfdis(defaultOptionClient.tax_regime_id, defaultOptionClient.type_person === TypePersonInvoiceEnum.MORAL ? false : true)
			}

			if (commercialLines?.length > 0)
				defaultOptionCommercial = {
					value: commercialLines[0]?.id_commercial_line,
					label: commercialLines[0]?.long_name,
					rfc: commercialLines[0]?.rfc,
					cp: urlClient === cedimi ? _cp : commercialLines[0]?.cp,

					//cp: commercialLines[0]?.cp,
					id_tax_regime: commercialLines[0]?.id_tax_regime,
					code_tax_regime: commercialLines[0]?.code_tax_regime,
					name_tax_regime: commercialLines[0]?.name_tax_regime,
					type_person: commercialLines[0]?.type_person ? TypePersonInvoiceEnum.MORAL : TypePersonInvoiceEnum.FISICA,
				};

			setFormInvoice((prev) => ({
				...prev,
				client_id: _id_company_r,
				client_business_id: defaultOptionClient?.value,
				receptor_information: defaultOptionClient,
				type: ReceptorInvoice.COMPANY,
				commercial_line_id: defaultOptionCommercial.value,
				issuing_information: {
					name: defaultOptionCommercial?.label ?? "",
					rfc: defaultOptionCommercial?.rfc ?? "",
					cp: defaultOptionCommercial?.cp ?? "",
					code_tax_regime: defaultOptionCommercial?.code_tax_regime ?? "",
					name_tax_regime: defaultOptionCommercial?.name_tax_regime ?? "",
					type_person: defaultOptionCommercial?.type_person ?? false
				},
				expedition_place: defaultOptionCommercial?.cp ?? "",
				id_payment_configuration: listBusinessNameClient?.[0]?.id_payment_configuration ?? 0,
				days_credit: listBusinessNameClient?.[0]?.days_credit ?? 0,
			}));

			if (id_work_order_r !== undefined && parseInt(id_work_order_r) > 0)
				await handleChangeFilterNims({
					value: id_work_order_r,
				}, false, {
					name: defaultOptionCommercial?.label ?? "",
					rfc: defaultOptionCommercial?.rfc ?? "",
					cp: defaultOptionCommercial?.cp ?? "",
					code_tax_regime: defaultOptionCommercial?.code_tax_regime ?? "",
					name_tax_regime: defaultOptionCommercial?.name_tax_regime ?? "",
					type_person: defaultOptionCommercial?.type_person ?? false,
					commercial_line_id: defaultOptionCommercial?.value
				}, _id_company_r, ReceptorInvoice.COMPANY);

			setViewInformationReceptor(true)
			setViewInformationIssuing(true);
			setByDashboard(true);
		}
		else if (id_patient_r !== undefined && parseInt(id_patient_r) > 0 && (_id_company_r !== undefined && parseInt(_id_company_r) === 0)) {
			open(modalFullRef);

			handleChangeTyepeReceptor(ReceptorInvoice.PATIENT);
			const getPatient = await getPatientById(id_patient_r);
			const commercialLines = await getAllCommercialLines();
			await GetListNimsByReceptor(id_patient_r);
			const branches = await getAllBranches();

			let _cp = branches.find(x => x.id_branch === parseInt(branchId))?.cp ?? null;


			let defaultOptionCommercial = null;

			if (commercialLines?.length > 0)
				defaultOptionCommercial = {
					value: commercialLines[0]?.id_commercial_line,
					label: commercialLines[0]?.long_name,
					rfc: commercialLines[0]?.rfc,
					//cp: commercialLines[0]?.cp,
					cp: urlClient === cedimi ? _cp : commercialLines[0]?.cp,

					id_tax_regime: commercialLines[0]?.id_tax_regime,
					code_tax_regime: commercialLines[0]?.code_tax_regime,
					name_tax_regime: commercialLines[0]?.name_tax_regime,
					type_person: commercialLines[0]?.type_person ? TypePersonInvoiceEnum.MORAL : TypePersonInvoiceEnum.FISICA,
				};

			if (!getPatient?.rfc || !getPatient?.id_tax_regime)
				setDisableStampOrder(true);

			setFormInvoice((prev) => ({
				...prev,
				patient_id: id_patient_r,
				type: ReceptorInvoice.PATIENT,
				receptor_information: {
					tax_regime_id: getPatient?.id_tax_regime ?? null,
					use_cfdi_id: getPatient?.id_use_cfdi ?? null,
					name_commercial_line: getPatient?.business_name ?? "",
					code_fiscal_regime: getPatient?.code_tax_regime ?? "",
					name_fiscal_regime: getPatient?.tax_regime ?? "",
					rfc: getPatient?.rfc ?? "",
					expedition_place: getPatient?.cp ?? "",
					type_person: getPatient?.type_person === 1 ? TypePersonInvoiceEnum.FISICA : TypePersonInvoiceEnum.MORAL,
					code_use_cfdi: getPatient?.code_use_cfdi ?? "",
					name_use_cfdi: getPatient?.name_use_cfdi ?? "",
					email: getPatient?.email ?? "",
					name_receptor: getPatient?.name_patient ?? ''
				},
				commercial_line_id: defaultOptionCommercial.value,
				issuing_information: {
					name: defaultOptionCommercial?.label ?? "",
					rfc: defaultOptionCommercial?.rfc ?? "",
					cp: defaultOptionCommercial?.cp ?? "",
					code_tax_regime: defaultOptionCommercial?.code_tax_regime ?? "",
					name_tax_regime: defaultOptionCommercial?.name_tax_regime ?? "",
					type_person: defaultOptionCommercial?.type_person ?? false
				},
				expedition_place: defaultOptionCommercial?.cp ?? ""
			}));

			if (getPatient?.id_tax_regime !== null)
				await GetUseCfdis(getPatient.id_tax_regime, getPatient?.type_person === 1 ? true : false);

			await handleChangeFilterNims({ value: id_work_order_r }, false, {
				name: defaultOptionCommercial?.label ?? "",
				rfc: defaultOptionCommercial?.rfc ?? "",
				cp: defaultOptionCommercial?.cp ?? "",
				code_tax_regime: defaultOptionCommercial?.code_tax_regime ?? "",
				name_tax_regime: defaultOptionCommercial?.name_tax_regime ?? "",
				type_person: defaultOptionCommercial?.type_person ?? false,
				commercial_line_id: defaultOptionCommercial?.value
			}, null, ReceptorInvoice.PATIENT);

			setViewInformationReceptor(true)
			setViewInformationIssuing(true);
			setByDashboard(true);
		}

	}, [_id_company_r, id_patient_r]);

	useEffect(() => {
		refetchAutoCompany()
	}, [refetchAutoCompany]);


	//#endregion

	useMemo(() => {

		if (formInvoice.listOrders?.length > 0) {
			let subtotal = 0;
			let discounts = 0;
			let taxes = 0;
			let retentions = 0;
			let total = 0;

			formInvoice.listOrders.forEach((order) => {
				if (!order?.is_deleted) {
					subtotal += order.import;
					discounts += order?.total_discount;
					taxes += order?.price_tax;
					retentions += order?.retention;
					total += order.total;
				}
			});

			setOptionsDue({
				subtotal: FormatAmount(subtotal, 2),
				discounts: FormatAmount(discounts, 2),
				tax: FormatAmount(taxes, 2),
				retentions: FormatAmount(retentions, 2),
				total: FormatAmount(total, 2)
			});
		}

	}, [formInvoice.listOrders])


	const GetCommercialLines = async () => {

		const commercialLines = await getAllCommercialLines();

		const branches = await getAllBranches();



		let _cp = branches.find(x => x.id_branch === parseInt(branchId))?.cp ?? null;



		if (commercialLines?.length > 0) {
			const list = commercialLines?.map(commercial => {
				return {
					value: commercial?.id_commercial_line,
					label: commercial?.long_name,
					rfc: commercial?.rfc,
					cp: urlClient === cedimi ? _cp : commercial?.cp,
					id_tax_regime: commercial?.id_tax_regime,
					code_tax_regime: commercial?.code_tax_regime,
					name_tax_regime: commercial?.name_tax_regime,
					type_person: commercial?.type_person ? TypePersonInvoiceEnum.MORAL : TypePersonInvoiceEnum.FISICA,
				}
			});
			setListCommercialLines(list);
		}
		else
			setListCommercialLines([]);
	}

	const GetAllClients = async () => {

		const listClients = await getAllClients();

		if (listClients?.length > 0) {
			const list = await Promise.all(
				listClients.map(async (client) => {
					let label = `${client?.code} ${client?.name}`;

					if (urlClient === cedimi) {
						const listBusinessNameClient = await getCompanyBusinessNameByClientId(client.id_company);
						if (listBusinessNameClient?.length > 0) {
							label += ` - ${listBusinessNameClient[0].business_name}`;
						}
						console.log("artemis 2");

					}

					return {
						value: client.id_company,
						label,
					};
				})
			);

			setListClients(list);
		} else {
			setListClients([]);
		}
	};






	const GetPayForms = async () => {
		const payForms = await getPayForms();

		if (payForms?.length > 0) {
			const list = payForms?.map(form => {
				return {
					label: form.abbreviation + " - " + form.name,
					value: form.id_pay_method,
					code: form.abbreviation
				}
			});

			setListPayForms(list);
		}
		else
			setListPayForms([]);
	}

	const GetPayFormsWorkOrder = async () => {
		const payForms = await getPayForms(true);

		if (payForms?.length > 0) {
			const list = payForms?.map(form => {
				return {
					label: form.abbreviation + " - " + form.name,
					value: form.id_pay_method,
					abbreviation: form.abbreviation
				}
			});

			setListPayFormsWorkOrder(list);
		}
		else
			setListPayFormsWorkOrder([]);
	}

	const GetUseCfdis = async (tax_regime_id, type_person) => {
		const listuseCfdi = await getListUseOfCfdi(
			tax_regime_id, type_person
		);

		if (listuseCfdi?.length > 0) {
			const list = listuseCfdi?.map(use => {
				return {
					value: use?.id_use_cfdi,
					label: `${use?.code} ${use?.name}`,
					code: use?.code
				};
			});

			setListUseOfCfdis(list);
		}
		else setListUseOfCfdis([]);
	}

	const [filteredNims, setFilteredNims] = useState([]);
	const [filterType, setFilterType] = useState('all');


	const GetListNimsByReceptor = async (patient_id, client_id) => {
		const listNims = await getWorkOrderByPatientOrCompany(patient_id, client_id, formInvoice.search_agreement === true ? formInvoice.id_agreement.value : null);

		if (listNims?.length > 0) {

			const list = listNims?.map(order => {
				return {
					value: order?.id_work_order,
					label: (
						<>
							<img alt="flask" className="img-fluid text-info mr-2" src={require(order?.is_micro ? "../../assets/images/price/microType.svg" : "../../assets/images/flask_laboratory.svg")} style={{ width: "30px", height: "30px" }} />
							<b className={order?.is_micro ? "txt-secondary" : ""} >{order?.nim}  /   {order?.name_branch}  /   {order?.date_work_order}  /   {order?.name_patient}</b>
						</>
					),
					baseOption: `${order?.nim}  /   ${order?.name_branch}  /   ${order?.date_work_order}  /   ${order?.name_patient}`,
					is_micro: order?.is_micro
				}
			});
			setListFilterNims(list);
			setFilteredNims(list);
		}
	}

	// ?---
	const handleFilterChange = () => {

		switch (filterType) {

			case 'micro':
				setFilteredNims(listFilterNims.filter(item => item.is_micro));
				break;
			case 'notMicro':
				setFilteredNims(listFilterNims.filter(item => !item.is_micro));
				break;
			default:
				setFilteredNims(listFilterNims);
				break;
		}

	};

	useEffect(() => {
		handleFilterChange();
	}, [filterType]);


	const handleFilterSelect = (e) => {
		setFilterType(e);
	};

	const selectButtonOptions = [
		{ label: 'Filtrar todos', value: 'all' },
		{ label: `Filtrar ${_title_dashboard}`, value: 'micro' },
		{ label: 'Filtrar Clinicos', value: 'notMicro' }
	];







	const GetListTaxRegime = async (version, is_physical_person = null, is_moral_person = null) => {
		const listRegimes = await getTaxRegimeByTypePerson(version, is_physical_person, is_moral_person);

		if (listRegimes?.length > 0) {
			const list = listRegimes?.map(regime => {
				return {
					id_tax_regime: regime.id_tax_regime,
					name: `(${regime.code}) ${regime.name}`
				}
			});

			setListTaxRegimes(list);
		}
	}

	const GetBranches = async () => {
		const listBranches = await getListBranches();

		if (listBranches?.length > 0) {
			const list = listBranches?.map(branch => {
				return {
					value: branch.id_branch,
					label: branch.name
				}
			});

			setListBranches(list);
		}
	}

	const GetInvoiceById = async () => {
		setShowLoading(true);
		const MyInvoice = await GetInvoiceId(request_id_invoice);

		if (MyInvoice.code === 200) {
			open(modalFullRef);
			const data = MyInvoice?.data;

			setFilterTypeReceptor(data?.typeClient);

			let updateFormInvoice = formInvoice;

			if (data?.typeClient === ReceptorInvoice.GENERAL_PUBLIC) {
				updateFormInvoice = {
					...updateFormInvoice,
					client_id: null,
					client_business_id: null,
					patient_id: null,
					type: ReceptorInvoice.GENERAL_PUBLIC,
					is_general_public: true,
					receptor_information: {
						tax_regime_id: null,
						use_cfdi_id: InformationGeneralPublicEnum.CODE_USE_CFDI,
						name_commercial_line: InformationGeneralPublicEnum.COMMERCIAL_LINE,
						code_fiscal_regime: InformationGeneralPublicEnum.CODE_FISCAL_REGIME_616,
						name_fiscal_regime: InformationGeneralPublicEnum.NAME_FISCAL_REGIME_616,
						rfc: InformationGeneralPublicEnum.RFC,
						expedition_place: '',
						type_person: TypePersonInvoiceEnum.FISICA,
						code_use_cfdi: InformationGeneralPublicEnum.CODE_USE_CFDI,
						name_use_cfdi: InformationGeneralPublicEnum.NAME_USE_CFDI,
					},
					use_cfdi_id: {
						value: InformationGeneralPublicEnum.CODE_USE_CFDI,
						label: InformationGeneralPublicEnum.NAME_USE_CFDI,
					},
					pay_method_id: {
						value: "PUE",
						label: "(PUE) PAGO EN UNA SOLA EXHIBICIÓN",
					},
					periodicity_id: {
						value: data?.globalInvoice?.codeOfPeriodicity,
						label: `${data?.globalInvoice?.codeOfPeriodicity} - ${data?.globalInvoice?.nameOfPeriodicity}`
					},
					month_id: {
						value: data?.globalInvoice?.codeOfMonth,
						label: `${data?.globalInvoice?.codeOfMonth} - ${data?.globalInvoice?.nameOfMonth}`
					},
					year_billing: {
						value: data?.globalInvoice?.codeOfYear,
						label: data?.globalInvoice?.codeOfYear
					},
					include_sells: data?.configurationConceptBody?.includeConceptSell ?? false,
					include_name_patient: false,
					include_detail_period: data?.configurationConceptBody?.includePeriod ?? false,
				};

				setFilterDateRanges({
					startDate: data?.dateRanges.startDate,
					endDate: data?.dateRanges.endDate,
				});

				GetPayFormsWorkOrder();
				GetBranches();
			}
			else if (data?.typeClient === ReceptorInvoice.PATIENT) {
				const getPatient = await getPatientById(data?.patientId);
				await GetListNimsByReceptor(data?.patientId);

				updateFormInvoice = {
					...updateFormInvoice,
					patient_id: data?.patientId,
					type: ReceptorInvoice.PATIENT,
					receptor_information: {
						tax_regime_id: getPatient?.id_tax_regime ?? null,
						use_cfdi_id: getPatient?.id_use_cfdi ?? null,
						name_commercial_line: getPatient?.business_name ?? "",
						code_fiscal_regime: getPatient?.code_tax_regime ?? "",
						name_fiscal_regime: getPatient?.tax_regime ?? "",
						rfc: getPatient?.rfc ?? "",
						expedition_place: getPatient?.cp ?? "",
						type_person: getPatient?.type_person === 1 ? TypePersonInvoiceEnum.FISICA : TypePersonInvoiceEnum.MORAL,
						code_use_cfdi: getPatient?.code_use_cfdi ?? "",
						name_use_cfdi: getPatient?.name_use_cfdi ?? "",
						email: getPatient?.email ?? "",
						name_receptor: getPatient?.name_patient ?? ''
					}
				}

				if (getPatient?.id_tax_regime !== null)
					await GetUseCfdis(getPatient.id_tax_regime, getPatient?.type_person === 1 ? true : false);
			}
			else if (data?.typeClient === ReceptorInvoice.COMPANY) {
				setSelectCompany({
					label: data?.nameReceptor,
					value: data?.clientId
				});

				const getList = await getCompanyBusinessNameByClientId(data?.clientId);
				console.log("artemis4");


				const list = getList?.map(bussinessName => {
					return {
						"value": bussinessName.id_company_business_name,
						"label": bussinessName.business_name,
						"id_company": bussinessName.id_company,
						"tax_regime_id": bussinessName.id_tax_regime ?? null,
						"use_cfdi_id": null,
						"rfc": bussinessName.rfc ?? "",
						"address": bussinessName.address,
						"colony": bussinessName.colony,
						"cp": bussinessName.cp ?? "",
						"phone": bussinessName.phone,
						"email": bussinessName.email,
						"code_tax_regime_business_name": bussinessName.code_tax_regime,
						"name_tax_regime": bussinessName.name_tax_regime,
						"type_person": bussinessName.type_person === 2 ? TypePersonInvoiceEnum.MORAL : TypePersonInvoiceEnum.FISICA,
						"name_receptor": data?.nameReceptor ?? '',
					}
				});

				setListClientCompanyBUsinessName(list);

				const businessId = list.find(business => business.value === data?.clientBusinessId);
				setSelectCommercialNameCompany(businessId);

				updateFormInvoice = {
					...updateFormInvoice,
					client_id: data?.clientId,
					client_business_id: data?.clientBusinessId,
					type: ReceptorInvoice.COMPANY,
					receptor_information: {
						name_commercial_line: businessId?.label ?? "",
						tax_regime_id: businessId?.tax_regime_id,
						use_cfdi_id: businessId?.use_cfdi_id,
						code_fiscal_regime: businessId?.code_tax_regime_business_name ?? "",
						name_fiscal_regime: businessId?.name_tax_regime ?? "",
						rfc: businessId?.rfc ?? "",
						expedition_place: businessId?.cp ?? "",
						type_person: businessId?.type_person,
						code_use_cfdiL: businessId?.code_use_cfdi ?? null,
						name_use_cfdi: businessId?.name_use_cfdi ?? null,
						email: businessId?.email ?? ""
					}
				};

				if (businessId?.tax_regime_id !== null)
					GetUseCfdis(businessId?.tax_regime_id, businessId?.type_person === TypePersonInvoiceEnum.MORAL ? false : true);

				await GetListNimsByReceptor(
					null, data?.clientId, formInvoice.search_agreement === true ? formInvoice.id_agreement.value : null
				);
			}

			const commercialLines = await getAllCommercialLines();

			const findCommercialLine = commercialLines.find(
				com => com.id_commercial_line === data?.commercialLineId
			);

			const listOrders = data?.listOrders?.map((order) => {
				return {
					invoice_detail_id: order?.invoiceDetailId,
					class_product_code_service: order?.productCodeService ?? '',
					code_unit: order?.codeUnit ?? '',
					id_class_product_service: null,
					id_work_order: order?.workOrderId,
					id_work_order_exam: order?.workOrderExamId,
					id_work_order_profile: order?.workOrderProfileId ?? null,
					id_exam: order?.examId ?? null,
					id_profile: order?.profileId ?? null,
					id_price: order?.priceId ?? null,
					id_profile_price: order?.profilePriceId ?? null,
					id_profile_curve_price: order?.curvePriceId ?? null,
					id_product_code_service: null,
					id_unit: null,
					nim: order?.nim ?? '',
					identification_code: order?.identificationCode ?? "",
					name: order?.description ?? '',
					price: order?.price ?? 0,
					price_urgent: order?.priceUrgent ?? 0,
					import: order?.import ?? 0,
					price_tax: order?.priceTax ?? 0,
					total_discount: order?.totalDiscount ?? 0,
					total: order?.total ?? 0,
					product_code_service: order?.productCodeService ?? "",
					name_unit: order?.nameUnit ?? '',
					name_patient: order?.namePatient ?? '',
					retention: order?.totalRetention ?? 0,
					is_deleted: false
				}
			});

			updateFormInvoice = {
				...updateFormInvoice,
				invoice_id: data?.invoiceId ?? null,
				commercial_line_id: data?.commercialLineId,
				issuing_information: findCommercialLine === null ? null : {
					name: findCommercialLine?.long_name,
					rfc: findCommercialLine?.rfc,
					cp: findCommercialLine?.cp,
					id_tax_regime: findCommercialLine?.id_tax_regime,
					code_tax_regime: findCommercialLine?.code_tax_regime,
					name_tax_regime: findCommercialLine?.name_tax_regime,
					type_person: findCommercialLine?.type_person ? TypePersonInvoiceEnum.MORAL : TypePersonInvoiceEnum.FISICA,
				},
				expedition_place: findCommercialLine?.cp,
				use_cfdi_id: {
					value: data?.configurationBody?.useCfdiId,
					label: `${data?.configurationBody?.codeOfUseCfdi} ${data?.configurationBody?.nameOfUseCfdi}`,
					code: data?.configurationBody?.codeOfUseCfdi
				},
				pay_method_id: {
					value: data?.configurationBody?.codePayMethod,
					label: data?.configurationBody?.codePayMethod === "PUE"
						? "(PUE) PAGO EN UNA SOLA EXHIBICIÓN"
						: "(PPD) PAGO EN PARCIALIDADES O DIFERIDO"
				},
				pay_form_id: {
					value: data?.configurationBody?.payFormId,
					label: `${data?.configurationBody?.codePayForm} ${data?.configurationBody?.namePayForm}`,
					code: data?.configurationBody?.codePayForm
				},
				payment_conditions: data?.paymentConditions ?? "",
				listOrders: listOrders,
				type_visualization: data?.typeVisualization,
				include_name_patient: data?.configurationConceptBody?.includeNamePatient,
				include_detail_period: data?.configurationConceptBody?.includePeriod,
				include_sells: data?.configurationConceptBody?.includeConceptSell,
				global_description: data?.configurationConceptBody?.globalDescription ?? 'ANALISIS CLINICOS',
				comments: data?.additionalComments ?? ''
			};

			setFormInvoice({
				...formInvoice,
				...updateFormInvoice
			});

			setViewInformationIssuing(true);
			setViewInformationReceptor(true);
			setIsEditInvoice(true);

			setShowLoading(false);
		}
		else if (MyInvoice.code === 401)
			validarSesion(history, MyInvoice.code, saveInvoice);
		else if (MyInvoice.code === 500) {
			createSweet("error", "error", "Factura", "Se perdio la conexión, con el servidor");
			setShowError(true);
		}
		else if (MyInvoice.code === 400) {
			createSweet("error", "error", "Factura", "No se llevo acabo la operación");
			setShowError(true);
		}
		else {
			createSweet("warning", "warning", "Factura", MyInvoice?.data?.msg);
			setShowError(true);
		}
		setShowLoading(false);

	}

	const handleChangeTyepeReceptor = (receptor) => {

		setFilterTypeReceptor(receptor);

		if (receptor === ReceptorInvoice.GENERAL_PUBLIC) {
			setFormInvoice({
				...formInvoice,
				client_id: null,
				client_business_id: null,
				patient_id: null,
				type: ReceptorInvoice.GENERAL_PUBLIC,
				is_general_public: true,
				receptor_information: {
					tax_regime_id: null,
					use_cfdi_id: InformationGeneralPublicEnum.CODE_USE_CFDI,
					name_commercial_line: InformationGeneralPublicEnum.COMMERCIAL_LINE,
					code_fiscal_regime: InformationGeneralPublicEnum.CODE_FISCAL_REGIME_616,
					name_fiscal_regime: InformationGeneralPublicEnum.NAME_FISCAL_REGIME_616,
					rfc: InformationGeneralPublicEnum.RFC,
					expedition_place: '',
					type_person: TypePersonInvoiceEnum.FISICA,
					code_use_cfdi: InformationGeneralPublicEnum.CODE_USE_CFDI,
					name_use_cfdi: InformationGeneralPublicEnum.NAME_USE_CFDI,
				},
				use_cfdi_id: {
					value: InformationGeneralPublicEnum.CODE_USE_CFDI,
					label: InformationGeneralPublicEnum.NAME_USE_CFDI,
				},
				pay_method_id: {
					value: "PUE",
					label: "(PUE) PAGO EN UNA SOLA EXHIBICIÓN",
				},
				// ? CLEAN
				invoice_id: null,
				commercial_line_id: null,
				issuing_information: null,
				branch_id: branchId,
				pay_form_id: null,
				periodicity_id: null,
				month_id: null,
				year_billing: {
					label: moment().format('YYYY'),
					value: moment().format('YYYY'),
				},
				expedition_place: null,
				payment_conditions: null,
				comments: "",
				include_name_patient: false,
				include_detail_period: false,
				include_sells: true,
				type_visualization: TypeVIsualizationEnum.DETAIL,
				listOrders: [],
				viewGeneral: {
					productCode: "",
					unitCode: "",
					nameUnit: "",
					numberIdentification: "",
					description: "",
					unitPrice: 0,
					import: 0,
					discount: 0,
					tax: 0,
					retention: 0,
					total: 0,
				},
				viewGroup: [],
				global_description: ''
			});
			setOptionsDue({
				...optionsDue,
				subtotal: 0,
				discounts: 0,
				tax: 0,
				retentions: 0,
				total: 0
			})

			setViewInformationReceptor(true);
			GetPayFormsWorkOrder();
			GetBranches();

		}
		else {
			setFormInvoice({
				...formInvoice,
				client_id: null,
				client_business_id: null,
				patient_id: null,
				receptor_information: null,
				pay_method_id: null,
				pay_form_id: null,
				use_cfdi_id: null,
				is_general_public: false,
				// ? clean
				invoice_id: null,
				commercial_line_id: null,
				issuing_information: null,
				type: null,
				branch_id: branchId,
				periodicity_id: null,
				month_id: null,
				year_billing: {
					label: moment().format('YYYY'),
					value: moment().format('YYYY'),
				},
				expedition_place: null,
				payment_conditions: null,
				comments: "",
				include_name_patient: true,
				include_detail_period: false,
				include_sells: false,
				type_visualization: TypeVIsualizationEnum.DETAIL,
				listOrders: [],
				viewGeneral: {
					productCode: "",
					unitCode: "",
					nameUnit: "",
					numberIdentification: "",
					description: "",
					unitPrice: 0,
					import: 0,
					discount: 0,
					tax: 0,
					retention: 0,
					total: 0,
				},
				viewGroup: [],
				global_description: ''
			});

			setOptionsDue({
				...optionsDue,
				subtotal: 0,
				discounts: 0,
				tax: 0,
				retentions: 0,
				total: 0
			})


			setViewInformationReceptor(false);

			if (receptor === ReceptorInvoice.COMPANY)
				GetAllClients();

		}
	}



	const handleChangePatient = async (e) => {
		const patient_id = e.target.value;

		if (patient_id !== 0 && patient_id !== null && patient_id !== "" && patient_id !== "0") {
			const getPatient = await getPatientById(patient_id);
			await GetListNimsByReceptor(patient_id);

			if (getPatient?.id_patient !== undefined) {
				setFormInvoice({
					...formInvoice,
					patient_id: patient_id,
					type: ReceptorInvoice.PATIENT,
					receptor_information: {
						tax_regime_id: getPatient?.id_tax_regime ?? null,
						use_cfdi_id: getPatient?.id_use_cfdi ?? null,
						name_commercial_line: getPatient?.business_name ?? "",
						code_fiscal_regime: getPatient?.code_tax_regime ?? "",
						name_fiscal_regime: getPatient?.tax_regime ?? "",
						rfc: getPatient?.rfc ?? "",
						expedition_place: getPatient?.cp ?? "",
						type_person: getPatient?.type_person === 1 ? TypePersonInvoiceEnum.FISICA : TypePersonInvoiceEnum.MORAL,
						code_use_cfdi: getPatient?.code_use_cfdi ?? "",
						name_use_cfdi: getPatient?.name_use_cfdi ?? "",
						email: getPatient?.email ?? "",
						name_receptor: getPatient?.name_patient ?? ''
					}
				});

				if (getPatient?.id_tax_regime !== null)
					await GetUseCfdis(getPatient.id_tax_regime, getPatient?.type_person === 1 ? true : false);

				setViewInformationReceptor(true);
			}
			else {
				if (getPatient.code === 401) {
					validarSesion(history, getPatient.code, getPatientById);
				}
				else if (getPatient.code === 500) {
					createSweet("warning", "warning", "Obtener información del paciente", "Ocurrio un problema al obtener la información del paciente");
				}
				else {
					createSweet("warning", "warning", "Paciente", getPatient.data.msg);
				}
			}
		}
		else {
			setFormInvoice({
				...formInvoice,
				patient_id: null,
				receptor_information: null,
			});

			setViewInformationReceptor(false);
		}
	}

	const handleChangeClient = async (e) => {
		setSelectCompany(e);
		console.log("🚀 ~ handleChangeClient ~ e:", e)
		if (e !== null && e?.value !== undefined) {
			const getList = await getCompanyBusinessNameByClientId(e.value);
			console.log("🚀 ~ handleChangeClient ~ getList:", getList)
			console.log("artemis 000");

			//	const idPaymentConfig = getList?.[0]?.id_payment_configuration ?? null;
			if (getList?.length > 0) {
				const list = getList?.map(bussinessName => {
					return {
						"value": bussinessName.id_company_business_name,
						"label": bussinessName.business_name,
						"id_company": bussinessName.id_company,
						"tax_regime_id": bussinessName.id_tax_regime ?? null,
						"use_cfdi_id": null,
						"rfc": bussinessName.rfc ?? "",
						"address": bussinessName.address,
						"colony": bussinessName.colony,
						"cp": bussinessName.cp ?? "",
						"phone": bussinessName.phone,
						"email": bussinessName.email,
						"code_tax_regime_business_name": bussinessName.code_tax_regime,
						"name_tax_regime": bussinessName.name_tax_regime,
						"type_person": bussinessName.type_person === 2 ? TypePersonInvoiceEnum.MORAL : TypePersonInvoiceEnum.FISICA,
						"name_receptor": e?.label ?? '',
						"is_stamp": bussinessName.is_stamp ?? true

					}
				});

				setListClientCompanyBUsinessName(list);
			}
			else setListClientCompanyBUsinessName([]);


			if (formInvoice.search_agreement) {
				const getAgreement = await getInformationAgreement(formInvoice.client_id);
				if (getAgreement !== null) {
					const list = getAgreement?.map(_find => {
						return {
							value: _find?.id_agreement,
							label: _find?.code,
						}
					});
					setListAgreement(list);
				}

				setFormInvoice({
					...formInvoice,
					search_agreement: true

				})

			}

			setFormInvoice({
				...formInvoice,
				client_id: e?.value,
				client_business_id: null,
				receptor_information: null,
				type: ReceptorInvoice.COMPANY,
				id_payment_configuration: getList?.[0]?.id_payment_configuration ?? 0,
				days_credit: getList?.[0]?.days_credit ?? 0,
				is_stamp: getList?.[0]?.is_stamp ?? true,

			});

			setViewInformationReceptor(false);


		}
		else {
			setFormInvoice({
				...formInvoice,
				client_id: null,
				client_business_id: null,
				receptor_information: null,
			});

			setViewInformationReceptor(false);
		}
	}

	const handleChangeClientBusinessId = async (e) => {
		setSelectCommercialNameCompany(e);
		if (e !== null) {
			await GetListNimsByReceptor(
				null, formInvoice.client_id, formInvoice.search_agreement === true ? formInvoice.id_agreement.value : null

			);

			setFormInvoice({
				...formInvoice,
				client_business_id: e.value,
				type: ReceptorInvoice.COMPANY,
				receptor_information: {
					name_commercial_line: e?.label ?? "",
					tax_regime_id: e.tax_regime_id,
					use_cfdi_id: e.use_cfdi_id,
					code_fiscal_regime: e?.code_tax_regime_business_name ?? "",
					name_fiscal_regime: e?.name_tax_regime ?? "",
					rfc: e?.rfc ?? "",
					expedition_place: e?.cp ?? "",
					type_person: e?.type_person,
					code_use_cfdiL: e?.code_use_cfdi ?? null,
					name_use_cfdi: e?.name_use_cfdi ?? null,
					email: e?.email ?? ""
				}
			});

			if (e?.tax_regime_id !== null)
				GetUseCfdis(e?.tax_regime_id, e?.type_person === TypePersonInvoiceEnum.MORAL ? false : true);

			setViewInformationReceptor(true);
		}
		else {
			setFormInvoice({
				...formInvoice,
				client_business_id: null,
				receptor_information: null,
			});

			setViewInformationReceptor(false);
		}
	}

	const msgs = useRef(null);
	const [listAgreement, setListAgreement] = useState([])


	// ? CONFIGURATION SEARCH AGREEMENT
	const searchAgreement = async () => {

		if (formInvoice.client_id === null) {
			if (msgs.current) {
				msgs.current.clear();
				msgs.current.show([
					{
						sticky: true,
						severity: 'error',
						icon: 'pi pi-question-circle',
						detail: 'Debe de seleccionar un cliente'
					},
				]);
			}
			return;
		}

		const getAgreement = await getInformationAgreement(formInvoice.client_id);
		if (getAgreement !== null) {
			const list = getAgreement?.map(_find => {
				return {
					value: _find?.id_agreement,
					label: _find?.code,
				}
			});
			setListAgreement(list);
		}

		setFormInvoice({
			...formInvoice,
			search_agreement: true

		})
		setListFilterNims([]);
	}

	const handleChangeAgreement = (e) => {
		if (e !== null) {
			setFormInvoice({
				...formInvoice,
				id_agreement: { value: e?.value, label: e?.label },
			});
		} else {
			setFormInvoice({
				...formInvoice,
				id_agreement: null,
				search_agreement: false
			});
		}
	}





	const handleViewFilters = () => setViewInformationReceptor(false);

	const handleChangeIssuing = (e) => {
		const issuing_information = e === null ? null : {
			name: e?.label,
			rfc: e?.rfc,
			cp: e?.cp,
			code_tax_regime: e?.code_tax_regime,
			name_tax_regime: e?.name_tax_regime,
			type_person: e?.type_person,
			commercial_line_id: e?.value
		};

		setFormInvoice({
			...formInvoice,
			commercial_line_id: e?.value ?? null,
			issuing_information: e === null ? null : {
				name: e?.label,
				rfc: e?.rfc,
				cp: e?.cp,
				code_tax_regime: e?.code_tax_regime,
				name_tax_regime: e?.name_tax_regime,
				type_person: e?.type_person
			},
			expedition_place: e?.cp
		});

		if (e !== null) {
			if (id_work_order_r !== undefined && parseInt(id_work_order_r) > 0) {
				handleChangeFilterNims({
					value: id_work_order_r,
				}, false, issuing_information);
			}

			setViewInformationIssuing(true);
		}
		else setViewInformationIssuing(false);
	}



	const handleChangeInput = (e, nameInput) => {

		if (nameInput === "periodicity_id") {
			if (e?.value === "05")
				setListOfMonths(listOfMonthsByGroupEnum);
			else
				setListOfMonths(listOfMonthsEnum);
		}

		let updateInputs = {};

		if (
			nameInput === "include_name_patient" ||
			nameInput === "include_detail_period" ||
			nameInput === "include_sells"
		) {
			updateInputs = {
				include_name_patient: nameInput === "include_name_patient" ? e : false,
				include_detail_period: nameInput === "include_detail_period" ? e : false,
				include_sells: nameInput === "include_sells" ? e : false
			};
		} else {
			updateInputs = {
				[nameInput]: e
			};
		}

		const newForm = {
			...formInvoice,
			...updateInputs
		};

		setFormInvoice(newForm);

		if (nameInput === "month_id") {
			handleCalculateDates(e.value, newForm);
		}

		if (nameInput === "periodicity_id") {
			handleCalculateDates(newForm.month_id?.value, newForm);
		}
	};

	const handleCalculateDates = (codeOfMonth, data = formInvoice) => {

		const periodicity = data.periodicity_id?.value;
		const year = data.year_billing?.value;
		const month = data.month_id?.value;

		if (!year) return;

		let date_start = "";
		let date_end = "";

		if (periodicity === "04") {

			if (!month) return;

			date_start = `${year}-${month}-01`;
			date_end = moment(date_start).endOf("month").format("YYYY-MM-DD");

			setFilterDateRanges({
				startDate: date_start,
				endDate: date_end
			});
		}
	};


	const handleChangeFilterNims = async (e, is_temp_patient = false, issuing_information = null, client_id = null, filterType = null) => {

		if (issuing_information === null && formInvoice?.issuing_information?.type_person === undefined) {
			createSweet("warning", "warning", "Emisor, razón social", "Selecciona un emisor");
			return;
		}

		const filterBy = filterType === null ? formInvoice.type : filterType;

		if (e?.value) {
			setIsLoadingWorkOrders(true);
		} else setIsLoadingWorkOrders(false);

		const detailWorkOrder = await getDetailWorkOrderByInvoice(e.value, issuing_information !== null ? issuing_information.type_person : formInvoice.issuing_information.type_person,
			filterBy === ReceptorInvoice.COMPANY ? (client_id === null ? formInvoice.client_id : client_id) : null
		);

		if (detailWorkOrder?.length > 0) {

			let _value_tax = 0

			detailWorkOrder.forEach(_tax => {
				_value_tax = _tax.value_tax

			});
			setValue_tax(_value_tax)

			if (!is_temp_patient) {

				let listTmpNims = listFilterNims;

				if (e.value !== 0) {
					listTmpNims.map(order => {
						if (e.value === order.value)
							order.isDisabled = true;

						return order;
					});
				}

				const listOrders = formInvoice.listOrders;

				if (listOrders?.find(order => order.id_work_order === e.value) !== undefined) {
					createSweet('warning', 'warning', 'El NIM seleccionado ya se encuentra seleccionado');
					setIsLoadingWorkOrders(false);
					setListFilterNims([...listTmpNims]);
					return;
				}

				listOrders.push(...detailWorkOrder);

				setFormInvoice((prev) => ({
					...prev,
					commercial_line_id: issuing_information !== null ? issuing_information.commercial_line_id : formInvoice.commercial_line_id,
					issuing_information: issuing_information !== null ? issuing_information : formInvoice.issuing_information,
					listOrders: [...listOrders]
				}));

				setListFilterNims([...listTmpNims]);
			}
			else {
				setIsLoadingWorkOrders(false);
				return detailWorkOrder;
			}
		}
		else if (detailWorkOrder?.code === 401) {
			validarSesion(history, detailWorkOrder.code, handleChangeFilterNims);
		}
		else if (detailWorkOrder?.code === 500) {
			createSweet("warning", "warning", "Obtener información del paciente", "Ocurrio un problema al obtener la información del paciente");
		}
		else {
			if (detailWorkOrder.msg === 'Error : La orden no se puede facturar, contactar con administración') {
				listFilterNims.forEach(_find => {
					createSweett("Contacta a Administración", _find.baseOption, "warning");
				});
			}
			else createSweet("warning", "warning", "Orden", detailWorkOrder.msg);
		}

		setIsLoadingWorkOrders(false);
	}

	const handleUpdateFiscalInformation = async () => {
		if (formInvoice.type === ReceptorInvoice.PATIENT) {
			setFormPatientFiscalInformation({
				business_name_patient: formInvoice.receptor_information?.name_commercial_line,
				code_tax_regime: formInvoice.receptor_information?.code_fiscal_regime,
				cp_patient: formInvoice.receptor_information?.expedition_place,
				email_patient: formInvoice.receptor_information?.email,
				name_patient: formInvoice.receptor_information?.name_receptor,
				rfc_patient: formInvoice.receptor_information?.rfc,
				tax_regime_id_patient: formInvoice.receptor_information?.tax_regime_id,
				type_person_patient: formInvoice.receptor_information?.type_person
			});
			setShowUpdateFiscalInformationPatient(true);
			await GetListTaxRegime("4.0", formInvoice.receptor_information?.type_person === TypePersonInvoiceEnum.FISICA ? true : null, formInvoice.receptor_information?.type_person === TypePersonInvoiceEnum.MORAL ? true : null);
			setDisableStampOrder(false);
		}
		else if (formInvoice.type === ReceptorInvoice.COMPANY) {
			setFormCompanyFiscalInformation({
				business_name_client: formInvoice.receptor_information?.name_commercial_line,
				code_tax_regime_client: formInvoice.receptor_information?.code_fiscal_regime,
				cp_client: formInvoice.receptor_information?.expedition_place,
				email_client: formInvoice.receptor_information?.email,
				rfc_client: formInvoice.receptor_information?.rfc,
				tax_regime_id_client: formInvoice.receptor_information?.tax_regime_id,
				type_person_client: formInvoice.receptor_information?.type_person
			});
			setShowUpdaetFiscalInformationClient(true);
			await GetListTaxRegime("4.0", formInvoice.receptor_information?.type_person === TypePersonInvoiceEnum.FISICA ? true : null, formInvoice.receptor_information?.type_person === TypePersonInvoiceEnum.MORAL ? true : null);
			setDisableStampOrder(false);
		}
	}

	const handleToggleModal = (type) => {
		if (type === "PATIENT")
			setShowUpdateFiscalInformationPatient(!showUpdateFiscalInformationPatient);
		else if (type === "CLIENT")
			setShowUpdaetFiscalInformationClient(!showUpdaetFiscalInformationClient);
		else if (type === "EXTRA_PATIENT")
			setShowExtraPatient(!showExtraPatient);
	}

	const handleChangeInputEditPatient = async (e) => {
		switch (e?.target?.name) {
			case "business_name_patient":
				setFormPatientFiscalInformation({
					...formPatientFiscalInformation,
					business_name_patient: e?.target?.value
				});
				break;
			case "rfc_patient":
				setFormPatientFiscalInformation({
					...formPatientFiscalInformation,
					rfc_patient: e?.target?.value
				});
				break;
			case "type_person_patient":
				setFormPatientFiscalInformation({
					...formPatientFiscalInformation,
					type_person_patient: e?.target?.value === "1" ? TypePersonInvoiceEnum.FISICA : TypePersonInvoiceEnum.MORAL,
					tax_regime_id_patient: 0,
				});

				await GetListTaxRegime("4.0", e?.target?.value === "1" ? true : null, e?.target?.value === "2" ? true : null);
				break;
			case "id_tax_regime_patient":
				setFormPatientFiscalInformation({
					...formPatientFiscalInformation,
					tax_regime_id_patient: e?.target?.value
				});
				break;
			case "cp_patient":
				setFormPatientFiscalInformation({
					...formPatientFiscalInformation,
					cp_patient: e?.target?.value
				});
				break;

			default:
				setFormPatientFiscalInformation({
					...formPatientFiscalInformation,
					email_patient: e?.target?.value
				});
				break;
		}
	}

	const handleChangeInputEditClient = async (e) => {
		switch (e?.target?.name) {
			case "business_name":
				setFormCompanyFiscalInformation({
					...formCompanyFiscalInformation,
					business_name_client: e?.target?.value
				});
				break;
			case "rfc_business_name":
				setFormCompanyFiscalInformation({
					...formCompanyFiscalInformation,
					rfc_client: e?.target?.value
				});
				break;
			case "id_tax_regime_business_name":
				setFormCompanyFiscalInformation({
					...formPatientFiscalInformation,
					tax_regime_id_client: e?.target?.value
				});
				break;
			case "cp_business_name":
				setFormCompanyFiscalInformation({
					...formCompanyFiscalInformation,
					cp_client: e?.target?.value
				});
				break;

			default:
				setFormCompanyFiscalInformation({
					...formCompanyFiscalInformation,
					email_client: e?.target?.value
				});
				break;
		}
	}

	const handleAddNewWorkOrder = () => {
		handleToggleModal("EXTRA_PATIENT");
	}

	const handleChangeAddNewWorkOrder = async (e) => {
		setSearchValueInput(e);

		const workOrderId = e?.target?.value ?? null;

		let listWOrdersTemp = listWorkOrdersTemp;

		if (workOrderId !== null) {
			if (listWorkOrdersTemp?.find(order => order.id_work_order === workOrderId) !== undefined) {
				createSweet('warning', 'warning', 'El NIM seleccionado ya se encuentra seleccionado');
				return;
			}

			const detailOrder = await handleChangeFilterNims({ value: workOrderId }, true);

			listWOrdersTemp.push(...detailOrder);

			setListWorkOrdersTemp([...listWOrdersTemp]);
		}
	}

	const handleConfirmExtraPatients = () => {
		if (listWorkOrdersTemp?.length === 0)
			handleToggleModal("EXTRA_PATIENT");
		else {
			let listTmpNims = listFilterNims;

			listTmpNims.map(order => {
				if (listWorkOrdersTemp?.find(order => order?.id_work_order === order.value) !== undefined)
					order.isDisabled = true;
				return order;
			});

			const listOrders = formInvoice.listOrders;
			listOrders.push(...listWorkOrdersTemp);

			setFormInvoice({
				...formInvoice,
				listOrders: [...listOrders]
			});

			setListFilterNims([...listTmpNims]);

			handleToggleModal("EXTRA_PATIENT");
			setListWorkOrdersTemp([]);

		}
	}

	const handleFilterDates = async (event, picker) => {

		if (formInvoice.issuing_information === null) {
			createSweet("warning", "warning", "Emisor", `Seleccione los  datos del emisor`);
			return;
		}

		setIsLoadingWorkOrders(true);

		setFilterDateRanges({
			...filterDateRanges,
			startDate: picker.startDate?.format("YYYY-MM-DD"),
			endDate: picker.endDate?.format("YYYY-MM-DD")
		});

		const detailWorkOrder = await getDetailWorkOrdersByDateRange(picker.startDate?.format("YYYY-MM-DD"), picker.endDate?.format("YYYY-MM-DD"), formInvoice.issuing_information.type_person,
			formInvoice.type === ReceptorInvoice.COMPANY ? formInvoice.client_id : null, formInvoice.search_agreement === true ? formInvoice.id_agreement.value : null
		);

		if (detailWorkOrder?.length === 0)
			createSweet("warning", "warning", "Orden", `No se encontraron resultados en el rango seleccionado`);
		else if (detailWorkOrder?.length > 0) {

			let _value_tax = 0

			detailWorkOrder.forEach(_tax => {
				_value_tax = _tax.value_tax

			});
			setValue_tax(_value_tax)
			const listOrders = formInvoice.listOrders;

			detailWorkOrder.forEach(order => {
				if (!listOrders?.some(list => list?.id_work_order_exam === order?.id_work_order_exam)) {
					listOrders.push(order);
				}
			});

			setFormInvoice({
				...formInvoice,
				listOrders: [...listOrders]
			});
		}
		else if (detailWorkOrder?.code === 401) {
			validarSesion(history, detailWorkOrder.code, handleFilterDates);
		}
		else if (detailWorkOrder?.code === 500) {
			createSweet("warning", "warning", "Obtener información del paciente", "Ocurrio un problema al obtener la información del paciente");
		}
		else {
			createSweet("warning", "warning", "Orden", detailWorkOrder.msg);
		}
		setIsLoadingWorkOrders(false);
	}

	// ? CONFIGURATION REMISSION
	const handleDateRemission = (event, picker) => {

		const selected = picker.startDate.format('YYYY-MM-DD[T]HH:mm:ss');

		setFormInvoice({
			...formInvoice,
			date_remission: selected
		});
	};


	const handleViewDate = () => {
		setFormInvoice({
			...formInvoice,
			is_date: true
		})
	}

	const handleClosed = () => {
		setFormInvoice({
			...formInvoice,
			is_date: false,
			date_remission: null
		})
	}

	let id_branch = localStorage.getItem('branchId');

	const [modalAlert, setModalAlert] = useState(false);
	const [messageAlert, setMessageAlert] = useState("")

	const toggleAlert = () => {
		setModalAlert(!modalAlert);
	}
	const [showInvoiceAlert, setShowInvoiceAlert] = useState(false);

	const handleFilterByGeneralPublic = async () => {
		setIsLoadingWorkOrders(true);


		if (filterByBranch?.value === undefined || filterByBranch?.value === null) {
			setShowInvoiceAlert(true)
			setModalAlert(true)
			setMessageAlert("Se seleccionarán todas las sucursales para esta factura.")

		}

		else if (Number(filterByBranch?.value) !== Number(id_branch)) {
			setIsLoadingWorkOrders(false);

			setMessageAlert("La sucursal seleccionada no coincide con tu sucursal asignada.");
			setShowInvoiceAlert(true)
			setModalAlert(true)


			return;
		}




		const detailWorkOrder = await getDetailWorkOrdersByGeneralPublic(formInvoice.periodicity_id?.value, filterDateRanges.startDate, filterDateRanges.endDate,
			filterByBranch?.value ?? null,
			filterByPayMethod?.value ?? null
		);

		if (detailWorkOrder?.length === 0)
			createSweet("warning", "warning", "Orden", `No se encontraron resultados en el rango seleccionado`);
		else if (detailWorkOrder?.length > 0) {
			const listOrders = [];

			detailWorkOrder.forEach(order => {
				if (!listOrders?.some(list => list?.id_work_order === order?.id_work_order)) {
					listOrders.push(order);
				}
			});

			setFormInvoice({
				...formInvoice,
				listOrders: [...listOrders]
			});
		}
		else if (detailWorkOrder?.code === 401) {
			validarSesion(history, detailWorkOrder.code, handleFilterDates);
			setFormInvoice({
				...formInvoice,
				listOrders: []
			});
		}
		else if (detailWorkOrder?.code === 500) {
			createSweet("warning", "warning", "Obtener información del paciente", "Ocurrio un problema al obtener la información del paciente");
			setFormInvoice({
				...formInvoice,
				listOrders: []
			});
		}
		else {
			createSweet("warning", "warning", "Orden", detailWorkOrder.msg);
			setFormInvoice({
				...formInvoice,
				listOrders: []
			});
		}
		setIsLoadingWorkOrders(false);
	}

	const handleChangeTypeVisualization = (e, nameInput) => {
		handleChangeInput(e, nameInput);
	}

	const handleDeleteTest = (id_exam = null, id_profile = null, id_work_order_exam = null, id_work_order_profile = null, _id_workOreder = null, _valid = false) => {

		let listTest = [];

		if (id_exam !== null && id_work_order_exam !== null) {
			listTest = formInvoice?.listOrders?.map(test => {
				if (test?.id_exam === id_exam && test?.id_work_order_exam === id_work_order_exam)
					return {
						...test,
						is_deleted: true
					};
				else
					return test;
			});
		}
		else if (id_profile !== null && id_work_order_profile !== null) {
			listTest = formInvoice?.listOrders?.map(test => {
				if (test?.id_profile === id_profile && test?.id_work_order_profile === id_work_order_profile)
					return {
						...test,
						is_deleted: true
					};
				else
					return test;
			});
		}

		if (_valid) {
			listTest = formInvoice?.listOrders?.map(test => {
				if (test?.id_work_order === _id_workOreder)
					return {
						...test,
						is_deleted: true
					};
				else
					return test;
			});

		}

		setFormInvoice({
			...formInvoice,
			listOrders: [...listTest]
		});
	}


	// ? CONFIGURATION INVOICES GLOBAL
	const handleCheckboxChange = (idWorkOrder) => {
		setCheckedItems((prev) => {
			const newState = { ...prev, [idWorkOrder]: !prev[idWorkOrder] };

			if (newState[idWorkOrder]) {
				setCheckedItemsPatient({});
			}

			return newState;
		});
	};

	// ? CONFIGURATION INVOICES PATIENT
	const handleCheckboxChangePatient = (idWorkOrder) => {
		setCheckedItemsPatient((prev) => {
			const newState = { ...prev, [idWorkOrder]: !prev[idWorkOrder] };

			if (newState[idWorkOrder]) {
				setCheckedItems({});
			}

			return newState;
		});
	};


	const handlePreviewGlobalInvoices = () => {

		setLoadingPreviewInvoices(!loadingPreviewInvoices);
		setShowPreviewInvoicesGlobal(!showPreviewInvoicesGlobal);

		setTimeout(() => {
			setLoadingPreviewInvoices(false);
		}, 3000);
	}

	const handleCancelGlobal = () => {
		setShowPreviewInvoicesGlobal(false);
		setCheckedItems({})
	}

	const handlePreviewPatientGlobal = () => {

		setLoadingPreviewInvoicesP(!loadingPreviewInvoicesP);
		setShowPreviewInvoicesPatient(!showPreviewInvoicesPatient);

		setTimeout(() => {
			setLoadingPreviewInvoicesP(false);
		}, 3000);
	}

	const handleCancelPatient = () => {
		setShowPreviewInvoicesPatient(false);
		setCheckedItemsPatient({})
	}

	const saveInvoicesGlobal = async () => {
		setLoadingGlobal(true)

		let _body = Object.keys(checkedItems)
			.filter(key => checkedItems[key])
			.map(key => ({
				"id_work_order": parseInt(key)
			}));

		const MyGlobalInvoice = await sendGlobalInvoices(_body);

		if (MyGlobalInvoice !== null) {

			setLoadingGlobal(false)
			createSweet("create", "info", "Exito!", "Se a mandado a público general!");

			let _validGlobal = formInvoice?.listOrders.map(_find => {

				if (checkedItems[_find?.id_work_order]) {
					return {
						..._find,
						is_deleted: true
					};
				}
				return _find;
			});
			handleCancelGlobal()
			setFormInvoice({
				...formInvoice,
				listOrders: _validGlobal
			});
		}
	}

	const saveInvoicesPatient = async () => {
		setLoadingGlobalPatient(true)

		let _body = Object.keys(checkedItemsPatient)
			.filter(key => checkedItemsPatient[key])
			.map(key => ({
				"id_work_order": parseInt(key)
			}));


		const MyGlobalInvoice = await sendPatientInvoices(_body);

		if (MyGlobalInvoice !== null) {

			setLoadingGlobal(false)
			createSweett("Factura a nombre del paciente", "Se a modifcado correctamente la configuración del nim", "success");

			let _validGlobal = formInvoice?.listOrders.map(_find => {
				const _key = `${_find?.id_work_order}-patient`;

				const isChecked = checkedItemsPatient?.[_key];

				if (isChecked) {

					return {
						..._find,
						is_deleted: true
					};
				}

				return _find;
			});

			handleCancelPatient()
			setFormInvoice({
				...formInvoice,
				listOrders: _validGlobal
			});
		}
	}


	const typeVisualizationTable = () => {
		if (formInvoice.type_visualization === TypeVIsualizationEnum.GLOBAL) {
			if (formInvoice?.listOrders?.length === 0)
				alert('You most select one option');
			else {
				setFormInvoice((prevState) => {
					let subtotal = 0;
					let discounts = 0;
					let taxes = 0;
					let retentions = 0;
					let total = 0;

					prevState.listOrders.forEach((order) => {
						if (!order?.is_deleted) {
							subtotal += order.import;
							discounts += order?.total_discount;
							taxes += order?.price_tax;
							retentions += order?.retention;
							total += order.total;
						}
					});

					return {
						...prevState,
						viewGeneral: {
							productCode: "85121801",
							unitCode: "E48",
							nameUnit: "UNIDAD DE SERVICIO",
							numberIdentification: "ESTUDIOS-LABORATORIO",
							description: "ANALISIS CLINICOS",
							unitPrice: subtotal,
							import: subtotal,
							discount: discounts,
							tax: taxes,
							retention: retentions,
							total,
						}
					}
				});
			}
		}
		else if (formInvoice.type_visualization === TypeVIsualizationEnum.TEST) {
			let aggroupTest = [];

			formInvoice.listOrders.forEach(test => {
				if (!test?.is_deleted) {
					if (test?.id_exam !== null) {
						const findExam = aggroupTest?.find(aggroup => aggroup?.id_exam === test?.id_exam);

						if (findExam !== undefined) {
							findExam.quantity += 1;
							// findExam.price += test?.price;
							// findExam.price_urgent += test?.price_urgent;
							findExam.import += test?.import;
							findExam.price_tax += test?.price_tax;
							findExam.total_discount += test?.total_discount;
							findExam.total += test?.total;
							findExam.retention += test?.retention;
							findExam.listWorkOrderExams.push(
								{
									InvoiceDetailId: test?.invoice_detail_id ?? null,
									WorkOrderId: test?.id_work_order ?? null,
									WorkOrderExamId: test?.id_work_order_exam ?? null,
									WorkOrderProfileId: null,
									PriceId: test?.id_price ?? null,
									ProfilePriceId: null,
									CurvePriceId: null,
									Quantity: 1,
									Total: test?.total,
									EnableRetention: formInvoice.type === ReceptorInvoice.GENERAL_PUBLIC ? (test?.total_retentions ?? 0) > 0 ? true : false : (test?.retention ?? 0) > 0 ? true : false,
									EnableTax: (test?.price_tax ?? 0) > 0 ? true : false,
								}
							);
						}
						else
							aggroupTest.push({
								id_exam: test?.id_exam,
								id_profile: null,
								name_test: test?.name ?? '',
								quantity: 1,
								price: test?.price,
								price_urgent: test?.price_urgent,
								import: test?.import,
								price_tax: test?.price_tax,
								total_discount: test?.total_discount,
								total: test?.total,
								class_product_code_service: test?.class_product_code_service,
								code_unit: test?.code_unit,
								name_unit: test?.name_unit,
								retention: test?.retention,
								identification_code: 'ESTUDIOS-LABORATORIO',
								listWorkOrderExams: [
									{
										InvoiceDetailId: test?.invoice_detail_id ?? null,
										WorkOrderId: test?.id_work_order ?? null,
										WorkOrderExamId: test?.id_work_order_exam ?? null,
										WorkOrderProfileId: null,
										PriceId: test?.id_price ?? null,
										ProfilePriceId: null,
										CurvePriceId: null,
										Quantity: 1,
										Total: test?.total,
										EnableRetention: formInvoice.type === ReceptorInvoice.GENERAL_PUBLIC ? (test?.total_retentions ?? 0) > 0 ? true : false : (test?.retention ?? 0) > 0 ? true : false,
										EnableTax: (test?.price_tax ?? 0) > 0 ? true : false,
									}
								]
							});

					}
					else if (test?.id_profile !== null) {
						const findProfile = aggroupTest?.find(aggroup => aggroup?.id_profile === test?.id_profile);

						if (findProfile !== undefined) {
							findProfile.quantity += 1;
							// findProfile.price += test?.price;
							// findProfile.price_urgent += test?.price_urgent;
							findProfile.import += test?.import;
							findProfile.price_tax += test?.price_tax;
							findProfile.total_discount += test?.total_discount;
							findProfile.total += test?.total;
							findProfile.retention += test?.retention;
							findProfile.listWorkOrderProfiles.push(
								{
									InvoiceDetailId: test?.invoice_detail_id ?? null,
									WorkOrderId: test?.id_work_order ?? null,
									WorkOrderExamId: null,
									WorkOrderProfileId: test?.id_work_order_profile,
									PriceId: null,
									ProfilePriceId: test?.id_profile_price,
									CurvePriceId: test?.id_profile_curve_price ?? null,
									Quantity: 1,
									Total: test?.total,
									EnableRetention: formInvoice.type === ReceptorInvoice.GENERAL_PUBLIC ? (test?.total_retentions ?? 0) > 0 ? true : false : (test?.retention ?? 0) > 0 ? true : false,
									EnableTax: (test?.price_tax ?? 0) > 0 ? true : false,
								}
							);
						}
						else
							aggroupTest.push({
								id_exam: null,
								id_profile: test?.id_profile,
								name_test: test?.name ?? '',
								quantity: 1,
								price: test?.price,
								price_urgent: test?.price_urgent,
								import: test?.import,
								price_tax: test?.price_tax,
								total_discount: test?.total_discount,
								total: test?.total,
								class_product_code_service: test?.class_product_code_service,
								code_unit: test?.code_unit,
								name_unit: test?.name_unit,
								retention: test?.retention,
								identification_code: 'ESTUDIOS-LABORATORIO',
								listWorkOrderProfiles: [
									{
										InvoiceDetailId: test?.invoice_detail_id ?? null,
										WorkOrderId: test?.id_work_order ?? null,
										WorkOrderExamId: null,
										WorkOrderProfileId: test?.id_work_order_profile,
										PriceId: null,
										ProfilePriceId: test?.id_profile_price,
										CurvePriceId: test?.id_profile_curve_price ?? null,
										Quantity: 1,
										Total: test?.total,
										EnableRetention: formInvoice.type === ReceptorInvoice.GENERAL_PUBLIC ? (test?.total_retentions ?? 0) > 0 ? true : false : (test?.retention ?? 0) > 0 ? true : false,
										EnableTax: (test?.price_tax ?? 0) > 0 ? true : false,
									}
								],
							})
					}
				}
			});

			setFormInvoice({
				...formInvoice,
				viewGroup: aggroupTest
			});
		}
		else if (formInvoice.type_visualization === TypeVIsualizationEnum.DETAIL) {
			setFormInvoice((prevState) => {
				return {
					...prevState,
					viewGeneral: {
						productCode: "",
						unitCode: "",
						nameUnit: "",
						numberIdentification: "",
						description: "",
						unitPrice: 0,
						import: 0,
						discount: 0,
						tax: 0,
						retention: 0,
						total: 0,
					}
				}
			})
		}
	}

	const handlePreviewInvoice = () => {
		if (formInvoice.listOrders.length === 0) {
			createSweet("warning", "warning", "Previsualización", "Selecciona al menos una orden");
			return;
		}

		setLoadingPreview(!loadingPreview);
		setShowPreviewInvoice(!showPreviewInvoice);
		GetSettings()

		setTimeout(() => {
			setLoadingPreview(false);
		}, 3000);
	}

	const handleLoadingPreInvoice = () => {
		setShowLoading(!showLoading);
	}

	const saveUpdateFiscalInformation = async (e) => {
		e.preventDefault();

		let newValidations = {};
		const validations = ValidateFiscalFormPatient(formPatientFiscalInformation, newValidations)
		if (validations.statusValidation) {
			setValidationsPatient(validations.newValidations);
			return;
		}

		const response = await updateFiscalInformationPatient({
			patient_id: formInvoice.patient_id,
			business_name: formPatientFiscalInformation.business_name_patient,
			cp: formPatientFiscalInformation.cp_patient,
			email: formPatientFiscalInformation.email_patient,
			id_tax_regime: formPatientFiscalInformation.tax_regime_id_patient,
			rfc: formPatientFiscalInformation.rfc_patient,
			type_person: formPatientFiscalInformation.type_person_patient
		});

		if (response.code === 200) {
			setFormPatientFiscalInformation({
				business_name_patient: response.data.business_name ?? '',
				code_tax_regime: response.data?.code_tax_regime ?? '',
				cp_patient: response.data?.postal_code ?? '',
				email_patient: response.data?.email,
				name_patient: response.data?.full_name ?? '',
				rfc_patient: response.data?.rfc ?? '',
				tax_regime_id_patient: response.data?.id_tax_regime,
				type_person_patient: response.data?.type_person === 1 ? TypePersonInvoiceEnum.FISICA : TypePersonInvoiceEnum.MORAL,
			});

			setFormInvoice({
				...formInvoice,
				receptor_information: {
					tax_regime_id: response.data?.id_tax_regime ?? null,
					use_cfdi_id: response.data?.id_use_cfdi ?? null,
					name_commercial_line: response.data?.business_name ?? "",
					code_fiscal_regime: response.data?.code_tax_regime ?? "",
					name_fiscal_regime: response.data?.name_tax_regime ?? "",
					rfc: response.data?.rfc ?? "",
					expedition_place: response.data?.postal_code ?? "",
					type_person: response.data?.type_person === 1 ? TypePersonInvoiceEnum.FISICA : TypePersonInvoiceEnum.MORAL,
					code_use_cfdi: response.data?.code_use_cfdi ?? "",
					name_use_cfdi: response.data?.name_use_cfdi ?? "",
					email: response.data?.email ?? "",
					name_receptor: response.data?.full_name ?? ''
				}
			});

			createSweet("create", "info", "Exito!", "Paciente actualizado");
			handleToggleModal("PATIENT");
			await GetUseCfdis(response.data?.id_tax_regime, response.data?.type_person === 1 ? true : false);
		}
		else if (response.code === 401)
			validarSesion(history, response.code, saveUpdateFiscalInformation);
		else if (response.code === 500)
			createSweet("error", "error", "Datos fiscales", "Se perdio la conexión, con el servidor");
		else if (response.code === 400)
			createSweet("error", "error", "Datos fiscales", "No se llevo acabo la operación");
		else
			createSweet("warning", "warning", "Datos fiscales", response.msg);
	}

	const saveUpdateClientInformation = async (e) => {
		e.preventDefault();

		let newValidations = {};
		const validations = ValidateFiscalFormClient(formCompanyFiscalInformation, newValidations);

		if (validations.statusValidation) {
			setValidationsBusinessName(validations.newValidations);
			return;
		}

		const response = await updateFiscalInformationClient({
			id_company_business_name: formInvoice.client_business_id,
			business_name: formCompanyFiscalInformation.business_name_client,
			cp: formCompanyFiscalInformation.cp_client,
			email: formCompanyFiscalInformation.email_client,
			id_tax_regime: formCompanyFiscalInformation.tax_regime_id_client,
			rfc: formCompanyFiscalInformation.rfc_client,
		});

		if (response.code === 200) {
			setFormInvoice({
				...formInvoice,
				receptor_information: {
					tax_regime_id: response.data?.tax_regime_id ?? null,
					use_cfdi_id: null,
					name_commercial_line: response.data?.business_name ?? "",
					code_fiscal_regime: response.data?.code_fiscal_regime ?? "",
					name_fiscal_regime: response.data?.fiscal_regime_name ?? "",
					rfc: response.data?.rfc ?? "",
					expedition_place: response.data?.expedition_place ?? "",
					type_person: response.data?.type_person === 1 ? TypePersonInvoiceEnum.FISICA : TypePersonInvoiceEnum.MORAL,
					code_use_cfdi: "",
					name_use_cfdi: "",
					email: response.data?.email ?? "",
					name_receptor: ''
				}
			});

			createSweet("create", "info", "Exito!", "Cliente actualizado");
			handleToggleModal("CLIENT");
		}
		else if (response.code === 401)
			validarSesion(history, response.code, saveUpdateClientInformation);
		else if (response.code === 500)
			createSweet("error", "error", "Datos fiscales", "Se perdio la conexión, con el servidor");
		else if (response.code === 400)
			createSweet("error", "error", "Datos fiscales", "No se llevo acabo la operación");
		else
			createSweet("warning", "warning", "Datos fiscales", response.msg);
	}


	// ? CONFIGURATION SETTINGS
	const GetSettings = async () => {

		const settings = await GetSettingsInvoice(formInvoice.branch_id, true, 1);
		const branches = await getAllBranches();


		if (settings?.data.length > 0) {

			let name_branch = branches.find(x => x.id_branch === parseInt(branchId))?.name ?? null;

			const list = settings?.data.map((form) => {
				return {
					branch: form.branch,
					serie: form.serie,
					branch_name: name_branch,
				};
			});

			setListSettings(list);
		} else setListSettings([]);
	};

	const [customAlert, setCustomAlert] = useState({
		visible: false,
		mode: "alert",
		type: "info",
		title: "",
		message: "",
		buttonText: "Aceptar",
		cancelText: null,
		onAccept: null,
		onCancel: null
	});


	const showCustomAlert = ({
		mode = "alert",
		type = "info",
		title,
		message,
		buttonText = "Aceptar",
		cancelText = null,
		onAccept = null,
		onCancel = null
	}) => {

		setCustomAlert({
			visible: true,
			mode,
			type,
			title,
			message,
			buttonText,
			cancelText,

			onAccept: () => {

				setCustomAlert(prev => ({
					...prev,
					visible: false
				}));

				if (onAccept) {
					onAccept();
				}

			},

			onCancel: () => {

				setCustomAlert(prev => ({
					...prev,
					visible: false
				}));

				if (onCancel) {
					onCancel();
				}

			}

		});

	};



	const saveInvoice = async (stamp_invoice = false) => {

		if ((formInvoice.client_id !== 0 && formInvoice.client_id !== null && formInvoice.client_id !== "") && !stamp_invoice) {

			if (!formInvoice?.is_stamp) {
				showCustomAlert({
					mode: "alert",
					type: "error",
					title: "No se puede timbrar",
					message: `El cliente solo puede realizar <strong>Prefacturas</strong>. Favor de revisar la configuración del cliente.`,
					buttonText: "Cancelar",
					handleAccept: () => {
					}
				});
				return;
			}

		}


		if ((formInvoice.client_id !== 0 && formInvoice.client_id !== null && formInvoice.client_id !== "") && stamp_invoice) {

			if (formInvoice?.is_stamp) {
				showCustomAlert({
					mode: "alert",
					type: "error",
					title: "No se puede timbrar",
					message: `El cliente solo puede realizar <strong>Facturas</strong>. Favor de revisar la configuración del cliente.`,
					buttonText: "Cancelar",
					handleAccept: () => {
					}
				});
				return;
			}
		}


		handleLoadingPreInvoice();


		const body = {
			InvoiceId: formInvoice.invoice_id,
			IsPreview: stamp_invoice,
			TypePersonIssuing: formInvoice.issuing_information.type_person,
			TypePersonReceptor: formInvoice.receptor_information.type_person,
			CommercialLineId: formInvoice.commercial_line_id,
			BranchId: formInvoice.branch_id,
			ClientId: formInvoice.client_id ?? null,
			ClientBusinessId: formInvoice.client_business_id ?? null,
			PatientId: formInvoice.patient_id ?? null,
			UseCfdiId: formInvoice.type === ReceptorInvoice.GENERAL_PUBLIC ? 0 : formInvoice.use_cfdi_id?.value ?? null,
			CodeOfUseCfdi: formInvoice.type === ReceptorInvoice.GENERAL_PUBLIC ? formInvoice.receptor_information.code_use_cfdi : formInvoice.use_cfdi_id?.code ?? null,
			PayFormId: formInvoice.pay_form_id?.value ?? null,
			CodePayForm: formInvoice.pay_form_id?.code ?? null,
			TypeDocument: 'I',
			CodePayMethod: formInvoice.pay_method_id?.value ?? null,
			ConfigurationConcepts: {
				IncludeNamePatient: formInvoice.include_name_patient,
				IncludePeriod: formInvoice.include_detail_period,
				IncludeConceptSell: formInvoice.include_sells,
				GlobalDescription: formInvoice.global_description ?? ''
			},
			DateRanges: filterDateRanges
				? {
					StartDate: filterDateRanges.startDate,
					EndDate: filterDateRanges.endDate
				}
				: null,
			ExpeditionPlace: formInvoice.expedition_place,
			GlobalInvoice: formInvoice.type === ReceptorInvoice.GENERAL_PUBLIC ? {
				CodeOfPeriodicity: formInvoice.periodicity_id?.value ?? null,
				CodeOfMonth: formInvoice.month_id?.value ?? null,
				CodeOfYear: formInvoice.year_billing?.value ?? null
			} : null,
			IsGeneralPublic: formInvoice.is_general_public,
			PaymentConditions: formInvoice.payment_conditions,
			AdditionalComments: formInvoice.comments ?? '',
			TypeClient: formInvoice.type,
			TypeVisualization: formInvoice.type_visualization,
			ListOrders: formInvoice.type_visualization === TypeVIsualizationEnum.GLOBAL ? formInvoice.listOrders?.filter(order => !order.is_deleted)?.map(order => {
				return {
					InvoiceDetailId: order?.invoice_detail_id ?? null,
					WorkOrderId: order?.id_work_order ?? null,
					WorkOrderExamId: order?.id_work_order_exam ?? null,
					WorkOrderProfileId: order?.id_work_order_profile ?? null,
					PriceId: order?.id_price ?? null,
					ProfilePriceId: order?.id_profile_price ?? null,
					CurvePriceId: order?.id_profile_curve_price ?? null,
					Quantity: 1,
					Total: order?.total ?? 0,
					EnableRetention: formInvoice.type === ReceptorInvoice.GENERAL_PUBLIC ? (order?.total_retentions ?? 0) > 0 ? true : false : (order?.retention ?? 0) > 0 ? true : false,
					EnableTax: (order?.price_tax ?? 0) > 0 ? true : false,
				}
			}) : [],
			ViewDetail: formInvoice.type_visualization === TypeVIsualizationEnum.DETAIL ? formInvoice.listOrders?.filter(order => !order.is_deleted)?.map(order => {
				return {
					ProductCode: formInvoice.type === ReceptorInvoice.GENERAL_PUBLIC ? order?.product_code_service ?? null : order?.class_product_code_service ?? null,
					IdentificationCode: formInvoice.type === ReceptorInvoice.GENERAL_PUBLIC ? order?.nim ?? null : order?.identification_code,
					Description: formInvoice.type === ReceptorInvoice.GENERAL_PUBLIC ? order?.name_patient ?? null : order?.name,
					UnitCode: order?.code_unit,
					Quantity: 1,
					Total: order?.total ?? 0,
					EnableRetention: formInvoice.type === ReceptorInvoice.GENERAL_PUBLIC ? (order?.total_retentions ?? 0) > 0 ? true : false : (order?.retention ?? 0) > 0 ? true : false,
					EnableTax: (order?.price_tax ?? 0) > 0 ? true : false,
					InvoiceDetailId: order?.invoice_detail_id ?? null,
					WorkOrderId: order?.id_work_order ?? null,
					WorkOrderExamId: order?.id_work_order_exam ?? null,
					WorkOrderProfileId: order?.id_work_order_profile ?? null,
					PriceId: order?.id_price ?? null,
					ProfilePriceId: order?.id_profile_price ?? null,
					CurvePriceId: order?.id_profile_curve_price ?? null,
					ListWorkOrderProfiles: [],
					ListWorkOrderExams: []
				}
			}) : [],
			ViewGeneral: formInvoice.type_visualization === TypeVIsualizationEnum.GLOBAL ? {
				ProductCode: formInvoice.viewGeneral?.productCode,
				IdentificationCode: formInvoice.viewGeneral?.numberIdentification,
				Description: formInvoice.viewGeneral?.description,
				UnitCode: formInvoice.viewGeneral?.unitCode,
				Quantity: 1,
				Total: formInvoice.viewGeneral?.total ?? 0,
				EnableRetention: (formInvoice.viewGeneral?.retention ?? 0) > 0 ? true : false,
				EnableTax: (formInvoice.viewGeneral?.tax ?? 0) > 0 ? true : false,
				ListWorkOrderProfiles: [],
				ListWorkOrderExams: []
			} : null,
			ViewGroup: formInvoice.type_visualization === TypeVIsualizationEnum.TEST ? formInvoice.viewGroup?.map(order => {
				return {
					ProductCode: formInvoice.type === ReceptorInvoice.GENERAL_PUBLIC ? order?.product_code_service ?? null : order?.class_product_code_service,
					IdentificationCode: formInvoice.type === ReceptorInvoice.GENERAL_PUBLIC ? order?.nim ?? null : order?.identification_code,
					Description: formInvoice.type === ReceptorInvoice.GENERAL_PUBLIC ? order?.name_patient ?? null : order?.name_test,
					UnitCode: order?.code_unit,
					Quantity: order?.quantity,
					Total: order?.total ?? 0,
					EnableRetention: formInvoice.type === ReceptorInvoice.GENERAL_PUBLIC ? (order?.total_retentions ?? 0) > 0 ? true : false : (order?.retention ?? 0) > 0 ? true : false,
					EnableTax: (order?.price_tax ?? 0) > 0 ? true : false,
					ListWorkOrderExams: order?.listWorkOrderExams ?? [],
					ListWorkOrderProfiles: order?.listWorkOrderProfiles ?? [],
				}
			}) : [],
			FechaEmision: formInvoice?.is_date ? formInvoice?.date_remission : "N/A",
			id_payment_configuration: formInvoice?.id_payment_configuration ?? null,
			days_credit: formInvoice?.days_credit ?? 0,
			id_agreement: formInvoice.id_agreement === null ? 0 : formInvoice.id_agreement.value ?? 0
		}

		const sendStamp = await sendStampIngress(body);

		if (sendStamp.code === 200) {
			createSweet("create", "info", "Exito!", "Se genero la factura con exito!");

			if (formInvoice.invoice_id !== null)
				setTimeout(() => {
					window.location.href = '../../../facturacion/Emitidos';
				}, 2000);
			else
				setTimeout(() => {
					window.location.replace('../invoice/service');
				}, 2000);
		}
		else if (sendStamp.code === 401)
			validarSesion(history, sendStamp.code, saveInvoice);
		else if (sendStamp.code === 500)
			createSweet("error", "error", "Factura", "Se perdio la conexión, con el servidor");
		else if (sendStamp.code === 400)
			createSweet("error", "error", "Factura", "No se llevo acabo la operación");
		else
			createSweet("warning", "warning", "Factura", sendStamp.msg);

		setShowLoading(false);
	}



	// ? CONFIGURATION EXIT INVOICE

	const handleClosedInvoiceIssued = () => {
		window.location.href = '../../../facturacion/Emitidos';
	}

	const handleClosedInvoiceDashboard = () => {
		window.location.replace('../../../../dashboard/default');

	}


	return {
		showUpdateFiscalInformationPatient, showUpdaetFiscalInformationClient, showExtraPatient, showPreviewInvoice, byDashboard, disableStampOrder,

		setShowCardFilterByDate, showCardFilterByDate, isEditInvoice, showError,

		filterByBranch, setFilterByBranch,

		filterByPayMethod, setFilterByPayMethod,

		viewInformationReceptor, viewInformationIssuing,

		listCommercialLines, listClients, listClientCompanyBUsinessName, listPayMethods,
		listPayForms, listUseOfCfdis, listFilterNims, listTaxRegimes, listOfPeriodicity, listOfMonths,
		listBranches, listPayFormsWorkOrder,

		listWorkOrdersTemp,

		formInvoice, formPatientFiscalInformation, formCompanyFiscalInformation,

		filterTypeReceptor, searchPatientState, searchExtraPatient, searchValueInput,

		selectCompany, selectCommercialNameCompany,

		filterDateRanges, setFilterDateRanges, optionsDue,

		isLoadingWorkOrders,

		loadingPreview, showLoading,

		handleChangeTyepeReceptor,
		handleChangePatient,
		handleChangeClient,
		handleChangeIssuing,
		handleChangeClientBusinessId,
		handleViewFilters,
		handleChangeInput,
		handleChangeFilterNims,
		handleUpdateFiscalInformation,
		handleToggleModal,
		handleChangeInputEditPatient,
		handleChangeInputEditClient,
		handleConfirmExtraPatients,

		handleAddNewWorkOrder,
		handleChangeAddNewWorkOrder,

		handleFilterDates,
		handleFilterByGeneralPublic,
		handleChangeTypeVisualization,

		handleDeleteTest,

		handlePreviewInvoice, handleLoadingPreInvoice,

		saveUpdateFiscalInformation, saveUpdateClientInformation,
		saveInvoice,

		validationsPatient, validationsBusinessName,

		checkedItems, handleCheckboxChange, saveInvoicesGlobal,

		handlePreviewGlobalInvoices, loadingPreviewInvoices,
		showPreviewInvoicesGlobal, handleCancelGlobal, loadingGlobal,

		handleDateRemission, twoDaysAgo, today, handleViewDate, handleClosed,

		handleCheckboxChangePatient, checkedItemsPatient, saveInvoicesPatient,
		handlePreviewPatientGlobal, loadingGlobalPatient,
		showPreviewInvoicesPatient, handleCancelPatient, loadingPreviewInvoicesP,

		value_tax,

		modalFullRef, close, modalProps, handleReport,

		request_id_invoice, handleClosedInvoiceIssued, handleClosedInvoiceDashboard, id_work_order_r,

		// ? CONFIGURATION AGREEMENT
		searchAgreement, msgs, listAgreement, handleChangeAgreement,

		filteredNims, handleFilterSelect, selectButtonOptions, filterType, _active_micro, listSettings,


		toggleAlert, showInvoiceAlert, modalAlert, messageAlert,
		customAlert



	}
}
